import { Component, OnInit , Input , Output} from '@angular/core';
import { EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../layout/loader/loader.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-information-modal',
  standalone: true,
  imports: [LoaderComponent, CommonModule],
  templateUrl: './information-modal.component.html',
  styleUrl: './information-modal.component.scss'
})
export class InformationModalComponent implements OnInit {
	@Input() public loader : boolean = true;
	@Input() public title : string = '';
	@Input() public message : string = '';
	@Input() public mailPreviewContent : string = '';
	@Input() public previewError : string = '';
	@Input() public cancelButtonText : string = '';
	@Input() public confirmButtonText : string = '';
	@Output() passEntry: EventEmitter<any> = new EventEmitter();

	constructor(
  		public activeModal: NgbActiveModal
  	) { 
      
    }

	ngOnInit(): void {
		
	}
  
	confirm () {
		this.activeModal.close(true);
	}
  
	cancel () {
		this.activeModal.close(false);
	}
  
	close () {
		this.activeModal.close(false);
	}
}
